/* eslint-disable */
import TouristGroupFactory from '@/js/common/Domain/Factory/TouristGroup';
import {propsDecorator, viewModelDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import childesAgeFactory from '@/js/common/Domain/Factory/childesAgeFactory';
import ChildView from './ChildView';
import ChildesCollection from './ChildesCollection';

const MAX_CHILDES = 3;

@propsDecorator({
    itemView: ChildView,
    bindings: {
        '.js-collection': 'collection:$collection',
    },
})

@viewModelDecorator({
    defaults: {
        showMessage: false,
        selectIsOpen: false,
    },
})

export default class TouristGroupView extends Backbone.Epoxy.View {
    render() {
        //abstract method
    }

    initDOMVariables() {
        this.$adultsButtonset = $('.adults__buttonset', this.$el);
        this.$inputText = $('.formInputPlace', this.$el);
    }

    setLabel({
                 adults, kids, infants, $input,
             }) {
        // метод рендерит надпись в самой форме
        let kidsLabel;
        const adultsLabel = `${adults} взросл${(+adults).wordEnding('ый;ых;ых')}`;
        const kidsTotal = (kids || 0) + (infants || 0);

        if (kidsTotal > 0) {
            kidsLabel = kids > 0 ? 'ребенок;детей;детей' : 'младенец;младенца;младенцев';
        }
        const $inputText = $input || this.$inputText;
        $inputText.find('p').text(adultsLabel);

        if (kidsLabel) {
            $inputText.find('span').text(` и ${kidsTotal} ${kidsTotal.wordEnding(kidsLabel)}`).show();
            $inputText.find('p').removeClass('withoutKids');
        } else {
            $inputText.find('span').hide();
            $inputText.find('p').addClass('withoutKids');
        }
    }

    controlChanged(e) {
        // запись выбранных данных в модель
        const data = this.getTouristsFromCollection(e ? $(e.currentTarget).prev() : null);
        this.setLabel(data);
        this.model.set('model', new TouristGroupFactory(data), {initiator: 'view'});
        this.addEmptyChildSelect();
    }

    getTouristsFromCollection($input) {
        // $input нужет так как браузер не успевает проставить свойство и событие наступает раньше
        const collection = this.collection?.pluck('model');
        const adults = $input?.val?.() || $('input:checked', this.$adultsButtonset).val() || this.model?.get('model')?.get('adults');
        let infants = 0;
        let kids = 0;
        const ages = [];
        collection.forEach((item) => {
            const age = +item?.get('age');
            if (age >= 0 && age < 2) {
                infants++;
                ages.push(age);
            } else if (age >= 2 && age <= 17) {
                kids++;
                ages.push(age);
            }
        });
        return {
            adults,
            infants,
            kids,
            ages,
        };
    }

    setValue(model) {
        const {adults, kids, infants} = model.toJSON();
        this.$adultsButtonset.find(`[value="${adults}"]`).prop('checked', true);
        this.setLabel({adults, kids, infants});
    }

    modelChanged(event, model, context) {
        if (context?.initiator !== 'view') {
            if (model === null) {
                this.$el.addClass('disable');
            } else {
                this.$el.removeClass('disable');
                this.updateChildesList(model);
                this.setValue(model);
            }
        }
    }

    initDomEvents() {
        this.$el.addClass('disable');
        $('label', this.$adultsButtonset).on('click', $.proxy(this.controlChanged, this));
        $('> .formInput', this.$el).on('click', () => {
            if (!this.$el.hasClass('disable')) {
                this.$el.toggleClass('open');
                this.dataLayerAnalyticsEvent();
            }
        });
        $(document).on('click', (event) => {
            const $dropdowns = this.$el.filter('.open');
            const $clickedDropdown = $(event.target);
            const $clickedContainer = $clickedDropdown.parents('.formDropdown');
            const $hideDropdowns = $dropdowns.not($clickedContainer).not($clickedDropdown);

            $hideDropdowns.removeClass('open');
        });

        this.$el.addClass('disable');
    }

    initModelEvents() {
        this.model.on('change:model', this.modelChanged.bind(this));
    }

    dataLayerAnalyticsEvent() {
        this?.dataLayerAnalytics?.searchFieldsEvent('touristGroupOpen');
    }

    updateChildesList(model) {
        const childesArray = [];
        const {infants, kids, ages} = model.toJSON();
        const addChild = ({type, age}) => {
            let childesCount = 0;
            for (let i = 0; i < type; i++) {
                if (childesCount > MAX_CHILDES) break;
                childesArray.push(childesAgeFactory({age: isNaN(age) ? +ages[i] : +age}));
                childesCount++;
            }
        };

        const childes = (infants || 0) + (kids || 0);
        const setDefaultAges = childes !== ages?.length;

        if (!setDefaultAges) {
            addChild({type: childes});
        } else {
            addChild({type: kids, age: 11});
            addChild({type: infants, age: 1});
        }
        if (childesArray.length) {
            this.collection.reset(childesArray);
        }
        this.addEmptyChildSelect();
        if (setDefaultAges) {
            this.controlChanged();
        }
    }

    addEmptyChildSelect() {
        if (this.collection.length < this.MAX_CHILDES) {
            this.viewModel.set({showMessage: false});

            if (!this.collection.findWhere({model: null})) {
                this.collection.add(childesAgeFactory({age: null}));
            }
        } else {
            this.viewModel.set({showMessage: true});
        }
    }

    removeChild(model) {
        this.collection.remove(model);
        this.controlChanged();
        if (this.collection.length === this.MAX_CHILDES - 1) {
            this.addEmptyChildSelect();
        }
    }

    initialize(options = {}) {
        this.MAX_CHILDES = MAX_CHILDES;
        this.collection = new ChildesCollection();
        this.dataLayerAnalytics = options.dataLayerAnalytics;
        this.render();
        this.initDOMVariables();
        this.initDomEvents();
        this.initModelEvents();
    }
}